import { render, staticRenderFns } from "./DealerLogDetail.vue?vue&type=template&id=5ba0e2f8&scoped=true&"
import script from "./DealerLogDetail.vue?vue&type=script&lang=js&"
export * from "./DealerLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./DealerLogDetail.vue?vue&type=style&index=0&id=5ba0e2f8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba0e2f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
